import { render } from "./EnglishExemptionRefTable.vue?vue&type=template&id=1887f278&ts=true"
import script from "./EnglishExemptionRefTable.vue?vue&type=script&lang=ts"
export * from "./EnglishExemptionRefTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__